@if (broadcastMessages.length > 0) {
  <div>
    <h2 class="section-header">Announcements</h2>
    @for (msg of broadcastMessages; track msg) {
      <div class="grid-row announcement">
        <div class="date-item grid-col-2">
          <div class="date-entry">{{msg.messageStartDate | date: 'MMM. dd'}}
          </div>
        </div>
        <div class="story-item grid-col-8">{{msg.messageText}}</div>
      </div>
    }
  </div>
}
